import React from "react";
import { FaInstagram, FaTwitter, FaYoutube } from "react-icons/fa";
import { FaTiktok } from "react-icons/fa6";
import { FaMapMarkerAlt, FaPhoneAlt, FaEnvelope } from "react-icons/fa";
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <footer className="bg-green-800 text-white py-6">
      <div className="container mx-auto text-center space-y-4">
        <ul className="space-y-2">
          <li>
            <Link to="/disclaimersection" className="hover:underline">
              Terms & Conditions
            </Link>
          </li>
          <li>
            <Link to="/contactsection" className="hover:underline">
              Contact Us
            </Link>
          </li>
          <li>
            <Link to="/aboutmesection" className="hover:underline">
              About Us
            </Link>
          </li>
        </ul>

        {/* Center-Aligned Social Media Icons */}
        <div className="flex justify-center mt-6">
          <div className="flex space-x-4">
            <a
              href="https://www.tiktok.com/@solaris.surge"
              target="_blank"
              rel="noopener noreferrer"
              className="text-2xl hover:text-gray-400"
            >
              <FaTiktok />
            </a>
            <a
              href="https://www.instagram.com/solarissurge/"
              target="_blank"
              rel="noopener noreferrer"
              className="text-2xl hover:text-gray-400"
            >
              <FaInstagram />
            </a>
            <a
              href="https://x.com/SolarisSurge"
              target="_blank"
              rel="noopener noreferrer"
              className="text-2xl hover:text-gray-400"
            >
              <FaTwitter />
            </a>
            <a
              href="https://www.youtube.com/@odedeyidamilare"
              target="_blank"
              rel="noopener noreferrer"
              className="text-2xl hover:text-gray-400"
            >
              <FaYoutube />
            </a>
          </div>
        </div>

        <p className="flex justify-center items-start sm:items-center gap-2 text-[13px] sm:text-base leading-snug">
          <FaMapMarkerAlt className="mt-[2px] sm:mt-0 flex-shrink-0" />

          <span>
            B640 up, Electronics Section, Alaba Garage bustop, Alaba,
            <br className="sm:hidden" />
            <span className="sm:ml-2">international</span> Ojo, Lagos
          </span>
        </p>

        <p className="flex justify-center items-center gap-2">
          <FaPhoneAlt />
          +2348165213568
        </p>

        <p className="flex justify-center items-center gap-2">
          <FaEnvelope />
          info@solarissurge.net
        </p>

        {/* Copyright Section */}
        <div className="border-t border-gray-500 mt-6 pt-4 space-y-2 text-sm text-gray-300">
          <p>
            © 2024–2026{" "}
            <span className="font-semibold text-white">Solaris Surge</span>. All
            rights reserved.
          </p>

          <p className="text-xs text-gray-400">
            Website designed by{" "}
            <a
              href="https://tobi-babalola.netlify.app"
              target="_blank"
              rel="noopener noreferrer"
              className="font-medium text-[#F4B400] hover:text-yellow-300 transition-colors duration-200 underline-offset-2 hover:underline"
            >
              Tobi Babalola
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
